import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MOBILE_SCREEN_UTILS } from '../utils';
import * as _ from 'lodash';

export type TStatusConf = {
  status: string;
  displayName: string;
  mobile?: {
    active: TStyle;
    default: TStyle;
    colSize?: number;
  };
  web?: {
    active: TStyle;
    default: TStyle;
    colSize?: number;
  };
}[];

type TStyle = {
  backgroundColor?: string;
  border?: string;
  color?: string;
  padding?: string;
  'text-align'?: string;
  'border-bottom'?: string;
};

type Tconf = {
  status: string;
  displayName: string;
  style: TStyle;
  colSize: number | string;
}[];

@Component({
  selector: 'monorepo-status-header',
  templateUrl: './status-header.component.html',
  styleUrls: ['./status-header.component.scss'],
})
export class StatusHeaderComponent implements OnChanges {
  @Input() statusConf: TStatusConf = [];
  @Input() activeStatus!: TStatusConf[number]['status'];
  @Output() onStatusChange = new EventEmitter<TStatusConf[number]['status']>();

  @Input() isMobileOrTablet = false;

  @Input() conf: Tconf = [];

  constructor() {
    this.isMobileOrTablet = MOBILE_SCREEN_UTILS.isTabletScreen();
  }

  ngOnChanges() {
    _.each(this.statusConf, (status, ind) => {
      let confItem: Tconf[number] = {
        status: status.status,
        displayName: status.displayName,
        style: {},
        colSize: (this.isMobileOrTablet ? status.mobile?.colSize : status.web?.colSize) || 'auto',
      };

      if (this.activeStatus === status.status) {
        confItem = {
          ...confItem,
          style: {
            ...confItem.style,
            ...(this.isMobileOrTablet ? status.mobile?.active : status.web?.active),
          },
        };
      } else {
        confItem = {
          ...confItem,
          style: {
            ...confItem.style,
            ...(this.isMobileOrTablet ? status.mobile?.default : status.web?.default),
          },
        };
      }

      if (this.conf[ind]) {
        this.conf[ind] = {
          ...this.conf[ind],
          ...confItem,
        };
      } else {
        this.conf.push(confItem);
      }
    });
  }

  emitStatusChange(selectedStatus: TStatusConf[number]['status']) {
    this.onStatusChange.emit(selectedStatus);
  }
}
